export const checkRequireLabel = (label) => {
  if (label.required === 1) {
    return `${label.label}*`
  }

  return label.label
}
